module.exports = __webpack_public_path__ + "static/media/16c-03_Pasaje-2-2016-405x295mm-oleo-sobre-papel.982c778b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16c/16c-03_Pasaje-2-2016-405x295mm-oleo-sobre-papel.jpg
// module id = 194
// module chunks = 0